export const APP_ONLINE_STATUS = "APP_ONLINE_STATUS";